module.exports = __webpack_public_path__ + "static/media/AGT_MulImg_workflow.7b1200c5.gif";